/* lvx-cart-carousel.js
   Companion to lvx-cart-carousel.css.

   Three jobs:
   1. Define window.upsellCarousel. assets/upsell-simple.js calls upsellCarousel()
      after every upsell add-to-cart, but nothing in the theme ever defines it.
   2. Turn the theme's text "Add" button into a round basket icon and move it
      onto the product image.
   3. Add a price line when Liquid did not render one, and wire the dots/arrows.

   Every mutation is idempotent and guarded, so re-running is free. */

(function () {
  var BASKET =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<circle cx="9" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle>' +
    '<path d="M2 3h3l2.4 11.2a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6L21 7H6"></path></svg>';

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, Shopify.money_format || '{{amount}}');
      }
    } catch (e) {}
    var meta = document.querySelector('meta[name="currency"]');
    var code = (meta && meta.content) || 'GBP';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Liquid renders the price only when the block's "hide price" setting is off.
     When it is on, pull the price out of the ProductJson blob instead. */
  function ensurePrice(card) {
    if (card.querySelector('[class*="upsell-product-price-"], .lvx-upsell-price')) return;
    var blob = card.querySelector('script[id^="ProductJson-"]');
    var info = card.querySelector('[class*="upsell-product-info-column-"]');
    if (!blob || !info) return;
    var product;
    try {
      product = JSON.parse(blob.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;
    var input = card.querySelector('input[name="id"]');
    var chosen = null;
    if (input) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(input.value)) {
          chosen = product.variants[i];
          break;
        }
      }
    }
    if (!chosen) chosen = product.variants[0];
    if (chosen.price == null) return;
    var el = document.createElement('div');
    el.className = 'lvx-upsell-price';
    el.textContent = money(chosen.price);
    info.appendChild(el);
  }

  function roundButton(card) {
    var btn = card.querySelector('button[class*="upsell-add-button-"]');
    var image = card.querySelector('[class*="upsell-product-image-column-"]');
    var col = card.querySelector('.upsell-product-action-column');
    if (!btn || !image || !col) return;
    if (btn.getAttribute('data-lvx-icon') !== '1') {
      var label = (btn.textContent || '').trim();
      btn.setAttribute('aria-label', label || 'Add to cart');
      btn.setAttribute('title', label || 'Add to cart');
      btn.innerHTML = BASKET;
      btn.setAttribute('data-lvx-icon', '1');
    }
    if (col.parentElement !== image) image.appendChild(col);
  }

  function cardsIn(track) {
    return track.querySelectorAll('.upsell-product-container');
  }

  function step(track, dir) {
    var first = track.querySelector('.upsell-product-container');
    var w = first ? first.getBoundingClientRect().width + 10 : track.clientWidth * 0.5;
    track.scrollBy({ left: dir * w, behavior: 'smooth' });
  }

  function markActive(track, nav) {
    var cards = cardsIn(track);
    var dots = nav.querySelectorAll('.slide_item');
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var d = Math.abs(cards[i].offsetLeft - track.offsetLeft - track.scrollLeft);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    }
    for (var j = 0; j < dots.length; j++) {
      if (j === best) dots[j].classList.add('active');
      else dots[j].classList.remove('active');
    }
  }

  function wireNav(slider) {
    var track = slider.querySelector('.upsell_block_container');
    if (!track) return;
    var count = cardsIn(track).length;
    var nav = slider.querySelector('.dots-and-arrows');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'dots-and-arrows';
      slider.appendChild(nav);
    }

    /* One card fits on screen anyway. Leave the container empty-but-hidden
       rather than removing it: base.css hides empty divs, and an empty nav
       with padding would otherwise leave a gap. */
    if (count < 2) {
      nav.innerHTML = '';
      nav.style.display = 'none';
      nav.removeAttribute('data-lvx-count');
      return;
    }
    nav.style.display = '';

    if (nav.getAttribute('data-lvx-count') !== String(count)) {
      nav.innerHTML = '';

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'lvx-arrow';
      prev.setAttribute('aria-label', 'Previous');
      prev.textContent = '‹';
      nav.appendChild(prev);

      for (var i = 0; i < count; i++) {
        var dot = document.createElement('span');
        dot.className = 'slide_item';
        dot.setAttribute('data-index', String(i));
        nav.appendChild(dot);
      }

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'lvx-arrow';
      next.setAttribute('aria-label', 'Next');
      next.textContent = '›';
      nav.appendChild(next);

      nav.setAttribute('data-lvx-count', String(count));

      prev.addEventListener('click', function () {
        step(track, -1);
      });
      next.addEventListener('click', function () {
        step(track, 1);
      });
      nav.addEventListener('click', function (e) {
        var dot = e.target.closest ? e.target.closest('.slide_item') : null;
        if (!dot) return;
        var target = cardsIn(track)[parseInt(dot.getAttribute('data-index'), 10)];
        if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      track.addEventListener(
        'scroll',
        function () {
          clearTimeout(track._lvxScroll);
          track._lvxScroll = setTimeout(function () {
            markActive(track, nav);
          }, 60);
        },
        { passive: true }
      );
    }

    markActive(track, nav);
  }

  function run() {
    var sliders = document.querySelectorAll('.upsell_slider');
    for (var i = 0; i < sliders.length; i++) {
      var cards = sliders[i].querySelectorAll('.upsell-product-container');
      for (var j = 0; j < cards.length; j++) {
        ensurePrice(cards[j]);
        roundButton(cards[j]);
      }
      wireNav(sliders[i]);
    }
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(run, 80);
  }

  /* upsell-simple.js calls this by name after every add-to-cart. */
  window.upsellCarousel = run;

  document.addEventListener('cart-drawer:render', schedule);
  document.addEventListener('cart:refresh', schedule);

  function boot() {
    var drawer = document.querySelector('cart-drawer, .cart-drawer');
    if (drawer && !drawer._lvxObserved) {
      drawer._lvxObserved = true;
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
